import angular from 'angular'
//import uiBootstrap from 'angular-ui-bootstrap'
import webcolors from 'webcolors/webcolors'
import ColorInput from 'webcolors/color-input'
import ColorSpectrum from 'webcolors/color-spectrum'
import webmodals from 'webmodals/_webmodals.app'

export default angular.module('webcolors', ['webmodals','infinite-scroll','ui.bootstrap','ngStorage'])
    .value('webcolors', webcolors)
    .component('colorInput', ColorInput)
    .directive('colorSpectrum', ColorSpectrum)
    .name;